<template>
  <div class="track_detail">
    <div class="no_detail" v-if="!logisticsTrackingSections.length">
      <span class="colorR">暂无查询到轨迹</span>
    </div>
    <div class="track_detail_content" v-if="logisticsTrackingSections.length">
      <div v-for="(item, index) in logisticsTrackingSections" :key="index">
        <div class="track_detail_content_head flex" :class="{'marTop30': index > 0}">
          <div class="track_detail_content_country"><span>{{sectionTypeFilter(item.sectionType)}}</span>-<span>{{item.country}}</span>-
            <a :href="filterWebsite(item.carrierCode)" target="_blank">
              <span>（{{filterCarriers(item.carrierCode)}}）</span>
            </a>
          </div>
          <div class="state_tag" :class="classObject(item.trackingStatus)">{{searchResultFilter(item.trackingStatus)}}</div>
          <div v-if="item.logisticsTracking" class="track_detail_content_time color99">上次追踪到最新轨迹的时间：{{utils.timeFormat(item.lastestTrackTime, 'yyyy-MM-dd hh:mm:ss')}}</div>
        </div>
        <div class="track_detail_content_line marTop15"></div>
        <div>关联运单号：<span v-for="(o,l) in item.trackingNos" :key="l">{{o}}<span v-show="l!==(item.trackingNos.length-1)">，</span></span></div>
        <div class="track_detail_content_box marTop20" v-if="item.logisticsTracking">
          <div class="track_detail_content_bar"></div>
          <div class="flex marBott10" v-for="(t, i) in reverce(item.logisticsTracking.items)" :key="i">
            <div class="track_detail_dot marRight30" :class="{'back26': i === 0}"></div>
            <div :class="{'color99': i !== 0}" style="width:150px" class="marRight30">{{t.trackingTime.dateTime ? utils.timeFormat(t.trackingTime.dateTime, 'yyyy-MM-dd hh:mm:ss') : '暂无时间'}}</div>
            <div :class="{'color99': i !== 0}" style="width: 800px;">{{t.description}}</div>
          </div>
        </div>
        <div class="track_detail_content_box marTop20 colorR" v-else>暂无该段轨迹</div>
      </div>

    </div>
    <div class="track_detail_button flex" v-if="logisticsTrackingSections.length">
      <div class="flex">
        <a href="javascript:;"
          class="copy-text copy_button point color99"
          @click="copyTip"
          ref="copyText"
          :data-to="filterTrack(logisticsTrackingSections)">复制内容</a>
        <!-- <a href="javascript:;"
          class="copy-link copy_button point color99"
          @click="copyTipLink"
          ref="copyLink"
          :data-link="linkDetail(logisticsTrackingSections)">复制链接</a> -->
      </div>

    </div>
  </div>
</template>

<script>
import {logisticsTrackings} from '../../api/new/Shipment.js'
import ClipboardJS from 'clipboard'
import LocalStorage from '@/common/localStorage.js'
export default {
  props: {
    detail: {},
    index: ''
  },
  data () {
    return {
      lineText: [],
      trackingStatus: '',
      logisticsTrackingSections: []
    }
  },
  created () {
    console.log(this.detail)
    if (this.detail.logisticsTrackingSections.length) {
      this.logisticsTrackingSections = this.detail.logisticsTrackingSections
    }
    console.log('bb')
  },
  mounted () {
    this.copyFun()
  },
  watch: {
    // detail (n, o) {
    //   if (n.logisticsTrackingSections.length) {
    //     this.logisticsTrackingSections = n.logisticsTrackingSections
    //   }
    // }
  },
  methods: {
    filterWebsite(code){//链接到物流商官网
      let text = ''
      LocalStorage.get('carriers').map(function (item) {
        if (code === item.code) {
          text = item.officialWebsite
        }
      })
      return text
    },
    reverce(arr){
      let arr1 = JSON.parse(JSON.stringify(arr))
      return arr1.reverse()
    },
    filterCarriers (code) {
      let text = ''
      let vm = this
      LocalStorage.get('carriers').map(function (item) {
        if (code === item.code) {
          if (vm.$i18n.locale==='zh-cn'){
            text = item.zhName
          }
          if (vm.$i18n.locale==='en'){
            text = item.enName
          }
        }
      })
      return text
    },
    sectionTypeFilter (type) {
      switch (type) {
        case 'InternationalPostalOrigin':
          return '国际邮政-发件地'
          break
        case 'InternationalPostalDestination':
          return '国际邮政-目的地'
          break
        case 'InternationalPostal':
          return '国际邮政'
          break
        case 'InternationalExpress':
          return '国际快递'
          break
        case 'NormalExpress':
          return '普通快递'
          break
        case 'LogisticsAgent':
          return '物流货代'
      }
    },
    copyFun () {
      let c = new ClipboardJS('.copy-text', {
        text: function (trigger) {
          let ret = trigger.getAttribute('data-to')
          return ret
        }
      })
      let l = new ClipboardJS('.copy-link', {
        text: function (trigger) {
          let ret = trigger.getAttribute('data-link')
          return ret
        }
      })
      if (this.$refs.copyText) {
        this.$refs.copyText.addEventListener('click', function () {
          console.log(c.text)
        }, false)
      }
      if (this.$refs.copyLink) {
        this.$refs.copyLink.addEventListener('click', function () {
          console.log(l.text)
        }, false)
      }
    },
    beforeDestroy () {
      let c = new ClipboardJS('.copy-text', {
        text: function (trigger) {
          let ret = trigger.getAttribute('data-to')
          return ret
        }
      })
      c.destroy()
    },
    searchResultFilter (code) {
      switch (code) {
        case 'Pending':
          return '等待查询'
          break
        case 'NotFound':
          return '查询不到'
          break
        case 'InfoReceived':
          return '预报发货'
          break
        case 'InTransit':
          return '运输途中'
          break
        case 'ArrivedDelivery':
          return '到达待取'
          break
        case 'Delivering':
          return '派送途中'
          break
        case 'Delivered':
          return '成功派送'
          break
        case 'DeliveryFailure':
          return '投递失败'
          break
        case 'Return':
          return '包裹退回'
          break
        case 'Exception':
          return '包裹异常'
          break
      }
    },
    classObject (code) {
      switch (code) {
        case 'Pending':
          return 'back26'
          break
        case 'Searching':
          return 'back26'
          break
        case 'Failure':
          return 'backF2'
          break
        case 'Success':
          return 'backG2'
          break
        case 'Suspend':
          return 'backW'
          break
        case 'UnsupportedSearch':
          return 'backF2'
          break
        case 'NotProvideTracking':
          return 'backW'
          break
      }
    },
    linkDetail (detail) {
      const ml = process.env.NODE_ENV
      if (ml === 'development' || ml === 'test') {
        return this.replaceParamVal('https://trackingyee.globalpcf.net/trackingResults', 'id', this.trackingGroupId)
      } else if (ml === 'build') {
        return this.replaceParamVal('https://trackingyee.com/trackingResults', 'id', this.trackingGroupId)
      }
    },
    replaceParamVal (href, paramName, replaceWith) {
      let oUrl = href
      let re = eval('/(' + paramName + '=)([^&]*)/gi')
      let nUrl = oUrl.replace(re, paramName + '=' + replaceWith)
      return nUrl
    },
    filterTrack (detail) {
      let vm = this
      console.log(detail)
      let text = ''
      let no = vm.trackingNo + '-' + '\n'
      detail.map(function (item) {
        text += vm.sectionTypeFilter(item.sectionType) + '-' + item.country + '-' + vm.filterCarriers(item.carrierCode) + '\n'
        if (item.logisticsTracking) {
          item.logisticsTracking.items.map(function (t) {
            text += vm.utils.timeFormat(t.trackingTime.dateTime, 'yyyy-MM-dd hh:mm:ss') + '-' + t.description + '\n'
          })
        } else {
          text += '暂无该段轨迹' + '\n'
        }
      })
      return text
    },
    copyTip () {
      this.$message({
        message: '复制内容成功',
        type: 'success'
      })
    },
    copyTipLink () {
      this.$message({
        message: '复制链接成功',
        type: 'success'
      })
    },
  }
}
</script>

<style scoped>
.track_detail {
  padding: 15px 40px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
}
.no_detail {
  height: 32px;
  line-height: 32px;
}
.track_detail_content {
  width: 1200px;
}
.track_detail_content_head {
  height: 32px;
  line-height: 32px;
}
.track_detail_content_line {
  border-bottom: 1px solid #F5F5F5;
}
.track_detail_content_country {
  border-left: 2px solid #289efc;
  padding-left: 14px;
  width: 250px;
  margin-right: 50px;
}
.track_detail_content_box {
  position: relative;
}
.track_detail_content_bar {
  position: absolute;
  border-left: 1px solid #D2D2D2;
  left: 3px;
  height: calc(100% - 20px);
  top: 10px;
}
.track_detail_dot {
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: #D2D2D2;
  margin-top: 4px;
}
.state_tag {
  padding: 0 10px;
  height:20px;
  line-height: 20px;
  color: #ffffff;
  margin: 7px 0;
  border-radius:4px;
  text-align: center;
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/trackIdDetail.vue